import React from 'react';
import { Modal, Button, Icon } from 'antd';
import Viewer from 'react-viewer';
import 'react-viewer/dist/index.css';

class ModalLoggedSkill extends React.Component {

  constructor() {
    super();
    this.state = {
      imagePreview: false,
      image: "",
      index: 0
    }
  }

  shouldImageViewerOpen = (fileName) => {
    if (fileName &&
        (fileName.substr(fileName.length - 3) == 'jpg' ||
        fileName.substr(fileName.length - 3) == 'JPG' ||
        fileName.substr(fileName.length - 3) == 'png' ||
        fileName.substr(fileName.length - 3) == 'PNG' ||
        fileName.substr(fileName.length - 4) == 'jpeg' ||
        fileName.substr(fileName.length - 4) == 'JPEG')
      ) {
        return true
      } else {
        return false
      }
  }

  listenClicks = (e) => {
    if (e.target.className === 'ant-modal-body') {
      this.props.cancel()
    }
  }


  render() {
    const t = this.props.t

    return (
      <div onClick={(e) => this.listenClicks(e)}>
        <Modal
          className="edituser gallery"
          visible={this.props.isOpen}
          onCancel={this.props.cancel}
          width={680}
          footer={false}
        >
        {this.props.data.slice(this.state.index, this.state.index+6).map( data => {
          const attachments = data.attachments && Object.entries(data.attachments)
          return (
            <div className='galleryModal' style={{backgroundColor: 'white', padding: 20, width: 400}}>
              <h3>{t('Name')}</h3>
              <p>{data.name}</p>
              <h3>{t('Subject')}</h3>
              <p>{data.subject}</p>
              <h3>{t('Category')}</h3>
              <p>{data.category}</p>
              <h3>{t('ATL Cluster')}</h3>
              <p>{data.cluster}</p>
              <h3>{t('Level of Skill')}</h3>
              <p>{data.level}</p>
              {data.notes &&
                <div>
                  <h3>{t('Notes')}</h3>
                  <p>{this.props.data.notes}</p>
                </div>
              }
              {attachments &&
                <div>
                <h3>File Attached</h3>
                  <div>
                    {attachments.map(file => (
                      <div style={{display: 'inline-flex', width: '100%'}}>
                        <Icon style={{fontSize: '18px'}} type="file-text" />
                        {this.shouldImageViewerOpen(file[1].name) ?
                          <p style={{marginBottom: 0}} onClick={() => this.setState({image: file[1].path, imagePreview: true})}>{file[1].name}</p>
                        :
                          <a target="_blank" href={file[1].path}><p style={{marginBottom: 0}}>{file[1].name}</p></a>
                        }
                      </div>
                    ))}
                  </div>
                </div>
              }
          </div>
        )})}
        {this.state.index !== 0 && <Icon onClick={() => this.setState({index: this.state.index-6})} type="left" /> }
        {this.props.data.length>this.state.index+6 && <Icon onClick={() => this.setState({index: this.state.index+6})} type="right" /> }
        </Modal>
        <Viewer
          visible={this.state.imagePreview}
          onClose={() => { this.setState({ imagePreview: false }); } }
          images={[{src: this.state.image, alt: ''}]}
          attribute={false}
          drag={false}
          zoomable={false}
          rotatable={false}
          scalable={false}
          changable={false}
          noNavbar={true}
          noToolbar={true}
          noFooter={true}
        />
      </div>
    )
  }
}

export default ModalLoggedSkill;



// WEBPACK FOOTER //
// ./src/components/ModalLoggedSkill_gallery/index.jsx